import type { CareerOfferAttribution } from './attribution.ts';
import type { CareerOfferAttributionParameters } from './events.ts';

const omitCapturedAt = ({
	capturedAt: _,
	...utm
}: CareerOfferAttribution['firstTouch']) => utm;

export const toCareerOfferAttributionParameters = (
	attribution: CareerOfferAttribution | null,
): CareerOfferAttributionParameters | undefined =>
	attribution
		? {
				first_touch: omitCapturedAt(attribution.firstTouch),
				last_touch: omitCapturedAt(attribution.lastTouch),
			}
		: undefined;
